<h1 mat-dialog-title>Behandlungsraum</h1>
<mat-dialog-content>
    <div class="one-row">
        <mat-form-field>
            <mat-label>Raumnummer</mat-label>
            <input matInput [formControl]="raumNrCtrl" type="text" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field>
            <mat-label>Raumname</mat-label>
            <input matInput [formControl]="nameCtrl" type="text" />
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="!nameCtrl.valid">Speichern</button>
</mat-dialog-actions>
